import { bunja } from 'bunja';

import { EventEmitter } from '@flipster/utils/event-emitter';

import { weakR230522NormalSubSocketBunja } from '.';
import type { EventsJsonValue } from '../../model/prex.v2.r230522.events';

type NonNullableFields<T> = { [K in keyof T]-?: NonNullable<T[K]> };
export type R230522Events = NonNullableFields<EventsJsonValue>;
export type R230522EventEmitter = EventEmitter<R230522Events>;
export type R230522NormalSubEventTopic = keyof EventsJsonValue;

export const weakR230522NormalSubEventsBunja = bunja(() => {
  const { r230522NormalSubSocket } = bunja.use(weakR230522NormalSubSocketBunja);
  const events = new EventEmitter<R230522Events>();

  bunja.effect(() =>
    r230522NormalSubSocket.on('r230522event', (eventData) => {
      for (const [eventTopic, event] of Object.entries(eventData)) {
        events.emit(eventTopic as R230522NormalSubEventTopic, event);
      }
    }),
  );

  return { events };
});
weakR230522NormalSubEventsBunja.debugLabel = 'weakR230522NormalSubEventsBunja';
